import { ModalCenterInPage } from 'shared/components';

import { useSFDeleteItemConfirmLang } from './hooks';

export function SFDeleteItemConfirm(props: Props) {
  const { open, onClose, onConfirm } = props;
  const lang = useSFDeleteItemConfirmLang();

  return (
    <ModalCenterInPage
      open={open}
      onClose={onClose}
      title={lang.title}
      aria-label='substitution-flow-delete-item-confirm'
      paragraphs={{
        first: lang.description,
      }}
      actions={{
        secondaryBtn: {
          children: lang.action.cancelBtn,
          onClick: onClose,
        },
        primaryBtn: {
          children: lang.action.confirmBtn,
          onClick: onConfirm,
        },
      }}
    />
  );
}

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}
